// extracted by mini-css-extract-plugin
module.exports = {"highlight":"Highlight-module--highlight--gx5q3"};